import React from "react";
import { FormSection, InputField } from "../../../common/FormComponents";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";

type SocialMedia = {
  facebook: string;
  instagram: string;
  linkedin: string;
  tiktok: string;
  twitter: string;
  threads: string;
  youtube: string;
};

type SocialMediaSectionProps = {
  socialMedia: SocialMedia;
  onChange: ({
    platform,
    value,
  }: {
    platform: keyof SocialMedia;
    value: string;
  }) => void;
};

const SocialMediaSection = ({
  socialMedia,
  onChange,
}: SocialMediaSectionProps) => {
  const handleChange =
    (platform: keyof SocialMedia) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange({ platform, value: e.target.value });
    };

  return (
    <FormSection
      title="Social Media"
      tooltipText="Enter the company's social media profiles"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
        <InputField
          id="facebook"
          name="facebook"
          label="Facebook"
          value={socialMedia.facebook}
          onChange={handleChange("facebook")}
          startAdornment={
            <FacebookIcon fontSize="small" className="text-blue-600 mr-2" />
          }
          placeholder="https://facebook.com/company"
          tooltipText="Enter the company's Facebook profile URL"
        />

        <InputField
          id="instagram"
          name="instagram"
          label="Instagram"
          value={socialMedia.instagram}
          onChange={handleChange("instagram")}
          startAdornment={
            <InstagramIcon fontSize="small" className="text-pink-600 mr-2" />
          }
          placeholder="https://instagram.com/company"
          tooltipText="Enter the company's Instagram profile URL"
        />

        <InputField
          id="linkedin"
          name="linkedin"
          label="LinkedIn"
          value={socialMedia.linkedin}
          onChange={handleChange("linkedin")}
          startAdornment={
            <LinkedInIcon fontSize="small" className="text-blue-800 mr-2" />
          }
          placeholder="https://linkedin.com/company/company"
          tooltipText="Enter the company's LinkedIn profile URL"
        />

        <InputField
          id="twitter"
          name="twitter"
          label="X (Twitter)"
          value={socialMedia.twitter}
          onChange={handleChange("twitter")}
          startAdornment={
            <TwitterIcon fontSize="small" className="text-blue-400 mr-2" />
          }
          placeholder="https://x.com/company"
          tooltipText="Enter the company's X (Twitter) profile URL"
        />

        <InputField
          id="youtube"
          name="youtube"
          label="YouTube"
          value={socialMedia.youtube}
          onChange={handleChange("youtube")}
          startAdornment={
            <YouTubeIcon fontSize="small" className="text-red-600 mr-2" />
          }
          placeholder="https://youtube.com/c/company"
          tooltipText="Enter the company's YouTube channel URL"
        />

        <InputField
          id="tiktok"
          name="tiktok"
          label="TikTok"
          value={socialMedia.tiktok}
          onChange={handleChange("tiktok")}
          placeholder="https://tiktok.com/@company"
          tooltipText="Enter the company's TikTok profile URL"
        />

        <InputField
          id="threads"
          name="threads"
          label="Threads"
          value={socialMedia.threads}
          onChange={handleChange("threads")}
          placeholder="https://threads.net/@company"
          tooltipText="Enter the company's Threads profile URL"
        />
      </div>
    </FormSection>
  );
};

export default SocialMediaSection;
